<template>
  <v-app-bar
    app>
    <!-- <v-app-bar-nav-icon @click.stop="onClickBtn"/> -->
    <v-toolbar-title>
      <v-btn
        v-if='!isStorage'
        class="default v-btn--simple"
        dark
        icon
        @click.stop="toggleDrawer"
      >
        <v-icon>mdi-view-list</v-icon>
      </v-btn>
      {{ $route.name }}
    </v-toolbar-title>
    <change-password-modal v-model='changePassword' :forcePassword='forcePassword '/>
    <v-spacer />
    <v-toolbar-items>
      <v-flex
        align-center
        layout
        py-2>
        <v-autocomplete
          v-if='!isStorage'
          :value="app.protocol.id"
          :items="protocols"
          placeholder="Protocol"
          item-text="name"
          item-value="id"
          hide-details
          @change="selectCurrentProtocol" />

        <v-btn dark v-if="isEmulation" color="red" @click="stopEmulation">ATTENTION! You are in user emulation mode. Click to CANCEL</v-btn>

        <v-menu
          bottom
          left
          content-class="dropdown-menu"
          offset-y
          transition="slide-y-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              text
              color="black"
              v-on="on">
              {{ username }} &nbsp; <v-icon color="tertiary">mdi-account</v-icon>
            </v-btn>
          </template>

          <v-list dense v-if='!isStorage'>
            <v-list-item @click='changePassword = true'>Change password</v-list-item>
            <v-list-item to="/logout">
              Logout
            </v-list-item>
          </v-list>
        </v-menu>
      </v-flex>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>

import { mapMutations, mapState } from 'vuex'
import ChangePasswordModal from '../app/ChangePasswordModal'
import { getList } from '@/api/base_entity'
import moment from 'moment'
import { isEmulation, stopEmulation } from '@/utils/auth'


export default {
  data: () => ({
    title: null,
    responsive: false,
    responsiveInput: false,
    on: null,
    changePassword: false,
    forcePassword: false,
    protocols: [] // { id: -1, name: 'All Protocols' }],
  }),
  components: { ChangePasswordModal },
  computed: {
    ...mapState(['user', 'app']),
    isEmulation () {
      return isEmulation()
    },
    username () {
      return `${this.user.name} ${this.user.role !== 'Storage' ? this.user.surname : ''} (${this.user.role})`
    },
    isStorage () {
      return this.user && this.user.role === 'Storage'
    }
  },
  async mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)

    if (this.user.role && !this.isStorage) {

      const ret = await getList('protocol', { status: '!=CLOSE' }, { rowsPerPage: 100 })
      this.protocols = ret.data
      this.protocols.unshift({ id: -1, name: 'All Protocols' })

      if (moment(this.user.password_expire)<moment() && !this.isStorage && this.user.role !== 'EMN Client') {
        this.changePassword = true
        this.forcePassword = true
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer', 'setProtocol']),
    stopEmulation () {
      stopEmulation()
      location.reload()
    },
    toggleDrawer () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    },
    selectCurrentProtocol (protocolId) {
      if (typeof protocolId === 'undefined' || protocolId === null) {
        return this.setProtocol({ id: -1 })
      }
      const protocol = this.protocols.find(p => p.id === protocolId)
      this.setProtocol(protocol)
    }
  }
}
</script>
